import "core-js/modules/es6.regexp.replace";
import _slicedToArray from "@babel/runtime-corejs2/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import _getIterator from "@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es6.regexp.match";
import * as React from 'react';
import { LinkText } from '../Link';
import { Text } from './Text';
import { TextDefaultProps } from './Text.types';
/**
 * For the TagMatchConfig The tagname is just for human identification and doing some checks within the code.
 * Pattern basically idenitfies the markdown eg ** bold ** and __bold__ are identified with the bold pattern regex.
 * Once identified, we need to split the value and that is where replaceRegex is used.
 * Pattern is global and case insensitive so we do all the idenitification in one go and replaces thereafter.
 */

var renderIndexObj = {
  currentRender: [],
  currentIndex: 0
};
var linkRegex = {
  // Matches: [My inline link description](https://my-inline-link-url.com)
  // Additional Matches: [My link](https://new-tab-link.com){:target="_blank"}
  tagName: 'a',
  pattern: /\[([^\]]*)\]\(([^)]*)\)(\{:target="(.*?)"\})?/gi,
  replaceRegex: /\[([^\]]*)\]\(([^)]*)\)(\{:target="(.*?)"\})?/
};
var boldRegex = {
  // Matches: __bold text__ OR **bold text**
  tagName: 'b',
  pattern: /(\*\*|__)(.*?)\1/gi,
  replaceRegex: /(\*\*|__)(.*?)\1/
};
export var Markdown = function Markdown(_ref) {
  var markdown = _ref.markdown,
      size = _ref.size,
      children = _ref.children,
      linkMutator = _ref.linkMutator;
  if (children == null) return children;
  var render = [];

  if (markdown) {
    doEmptyOrNonEmptyRender(children, linkRegex, render, size, linkMutator);
    doEmptyOrNonEmptyRender(children, boldRegex, render, size, linkMutator);
  }

  return render.length === 0 ? children : render;
};
Markdown.defaultProps = {
  size: TextDefaultProps.size
};

var doEmptyOrNonEmptyRender = function doEmptyOrNonEmptyRender(text, regex, render, size, linkMutator) {
  if (render.length === 0) {
    render = processEmptyRender(text, regex, render, size, linkMutator);
  } else {
    render = processNonEmptyRender(regex, render, size);
  }
};

var processEmptyRender = function processEmptyRender(text, regex, render, size, linkMutator) {
  var matchArray = text.match(regex.pattern);
  var startIndex = 0;

  if (matchArray) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(matchArray.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            index = _step$value[0],
            matchedObj = _step$value[1];

        if (regex.tagName === 'a') {
          renderIndexObj = processAnchorTags(matchedObj, regex, render, startIndex, text, size, linkMutator);
        } else {
          renderIndexObj = processBoldTags(matchedObj, regex, render, startIndex, text, size);
        }

        startIndex = renderIndexObj.currentIndex; // If after processing there is any string left, add that back to the original array.

        if (index + 1 === matchArray.length) {
          render.push(text.slice(startIndex, text.length));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return render;
};

var processNonEmptyRender = function processNonEmptyRender(regex, render, size) {
  /* Since markdown is processed on the render object hence,
   * we need to now iterate on the render object with all the tags. if it has been manipulated before. */
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _getIterator(render.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          index = _step2$value[0],
          renderElement = _step2$value[1];

      var temporaryMergeArray = [];

      if (typeof renderElement === 'string') {
        var matchArray = renderElement.match(regex.pattern);

        if (matchArray) {
          var startIndex = 0;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = _getIterator(matchArray), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var matchedObj = _step3.value;
              var unprocessRenderArr = [];

              if (regex.tagName === 'b') {
                renderIndexObj = processBoldTags(matchedObj, regex, unprocessRenderArr, startIndex, renderElement, size);
                startIndex = renderIndexObj.currentIndex;
              }
              /* If multiple patterns match in the same string, we can't add that back to the original array
               * therefore creating a merged array object. Assising  the object back to the parent render object
               * post processing a line below.
               */


              temporaryMergeArray.push(unprocessRenderArr);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          temporaryMergeArray.push(renderElement.slice(startIndex, renderElement.length));
          render[index] = temporaryMergeArray;
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return render;
};

var processBoldTags = function processBoldTags(matchedObj, regex, render, startIndex, text, size) {
  var _matchedObj$match = matchedObj.match(regex.replaceRegex),
      _matchedObj$match2 = _slicedToArray(_matchedObj$match, 3),
      boldOriginal = _matchedObj$match2[0],
      boldMatch = _matchedObj$match2[1],
      boldText = _matchedObj$match2[2];

  render.push(text.slice(startIndex, text.indexOf(boldOriginal)));
  var currentIndex = text.indexOf(boldOriginal) + boldOriginal.length;
  render.push(React.createElement(Text, {
    key: startIndex,
    inline: true,
    fontWeight: "bold",
    children: boldText,
    size: size
  }));
  return {
    currentRender: render,
    currentIndex: currentIndex
  };
};

var processAnchorTags = function processAnchorTags(matchedObj, regex, render, startIndex, text, size, linkMutator) {
  var _matchedObj$match3 = matchedObj.match(regex.replaceRegex),
      _matchedObj$match4 = _slicedToArray(_matchedObj$match3, 5),
      linkOriginal = _matchedObj$match4[0],
      displayText = _matchedObj$match4[1],
      href = _matchedObj$match4[2],
      _ = _matchedObj$match4[3],
      target = _matchedObj$match4[4];

  render.push(text.slice(startIndex, text.indexOf(linkOriginal)));
  var currentIndex = text.indexOf(linkOriginal) + linkOriginal.length;
  var linkTextProps = {
    key: startIndex,
    text: displayText,
    'data-id': getDataIdFromText(displayText),
    target: target,
    href: href,
    size: size
  };

  if (linkMutator) {
    linkTextProps = linkMutator(linkTextProps);
  }

  render.push(React.createElement(LinkText, linkTextProps));
  return {
    currentRender: render,
    currentIndex: currentIndex
  };
};

var getDataIdFromText = function getDataIdFromText(text) {
  return text.replace(/\s+/g, '-').toLowerCase();
};

export default Markdown;